import { createFileRoute, Outlet } from '@tanstack/react-router'
import { nav_settings } from '@/integrations/paraglide/messages/_index.js'

export const Route = createFileRoute('/_authenticated/settings')({
	component: SettingsLayoutRoute,
	staticData: {
		breadcrumb: { label: nav_settings() },
	},
})

function SettingsLayoutRoute() {
	return <Outlet />
}
